export default "__VITE_ASSET__e4420382__"